// Dummy question set for the standalone questionnaire demo (/questionnaire-demo).
// Shape matches what the QuestionType components under Pages/Patient/QuestionTypes expect:
//   choices_en / instructions_en are JSON strings, question_type drives the rendered widget.

export const DUMMY_QUESTIONS = [
  {
    id: "1",
    question_type: "nan",
    question:
      "Welcome. PureGenomics® is backed by the science of nutrigenomics - the study of the relationships between our genes, nutrition, and health - and guided by your healthcare provider's expertise, to help create a reliable plan of care that's made just for you. A brief 5-7 minute questionnaire combined with your DNA test results will allow us to create reports full of personalised nutrition and lifestyle recommendations. Let's begin.",
  },
  {
    id: "2",
    question_type: "date",
    question:
      "Perfect. Let's start with some basics about you, your habits, nutrition and lifestyle, and then dive into health questions. Please share your date of birth.",
    instructions_en: "Select your date of birth.",
  },
  {
    id: "3",
    question_type: "radio",
    question:
      "Some may consider the next few questions sensitive. We take your privacy very seriously and rest assured we only use the information to personalise recommendations. Please share your gender assigned when you were born.",
    instructions_en: "Choose one answer.",
    choices_en: JSON.stringify(["Female", "Male"]),
  },
  {
    id: "4",
    question_type: "checkbox-radio",
    question:
      "Which of the following racial designations best describes you?",
    instructions_en: "Select all that apply.",
    choices_en: JSON.stringify([
      "American Indian or Alaska Native",
      "Asian",
      "Black or African American",
      "Native Hawaiian or Other Pacific Islander",
      "White",
      "Prefer not to answer",
    ]),
    choices: JSON.stringify([
      "American Indian or Alaska Native",
      "Asian",
      "Black or African American",
      "Native Hawaiian or Other Pacific Islander",
      "White",
      "Prefer not to answer",
    ]),
  },
  {
    id: "5",
    question_type: "radio",
    question: "Do you consider yourself Hispanic or Latino?",
    instructions_en: "Choose one answer.",
    choices_en: JSON.stringify(["Yes", "No", "Prefer not to say"]),
  },
  {
    id: "6",
    question_type: "radio",
    question: "Please select the term that best describes the area where you live.",
    instructions_en: "Choose one answer.",
    choices_en: JSON.stringify(["Urban", "Suburban", "Rural"]),
  },
  {
    id: "7",
    question_type: "radio",
    question:
      "Do you get 15-20 minutes of daily sun exposure directly on skin without sunscreen?",
    instructions_en: "Choose one answer.",
    choices_en: JSON.stringify([
      "Less than 15 minutes",
      "15-20 minutes",
      "More than 20 minutes",
      "I rarely go outside without sunscreen",
    ]),
  },
  {
    id: "8",
    question_type: "radio",
    question: "Do you currently take a vitamin D supplement?",
    instructions_en: "Choose one answer.",
    choices_en: JSON.stringify([
      "Yes, vitamin D3",
      "Yes, as part of a multivitamin",
      "No",
    ]),
  },
  {
    id: "9",
    question_type: "number",
    question: "What is your height?",
    instructions_en: "Enter your height in centimetres.",
    placeholder_en: "Height in cm",
  },
  {
    id: "10",
    question_type: "number",
    question: "What is your weight?",
    instructions_en: "Enter your weight in kilograms.",
    placeholder_en: "Weight in kg",
  },
  {
    id: "11",
    question_type: "text",
    question:
      "Do you have any food allergies or intolerances we should be aware of?",
    instructions_en: "Type your answer, for example: lactose intolerance, peanut allergy.",
  },
  {
    id: "12",
    question_type: "radio",
    question: "How much caffeine do you consume on a typical day?",
    instructions_en: "Choose one answer.",
    choices_en: JSON.stringify([
      "None",
      "1-2 cups of coffee per day",
      "3-4 cups of coffee per day",
      "More than 4 cups of coffee per day",
    ]),
  },
  {
    id: "13",
    question_type: "checkbox-radio",
    question: "Which of the following best describes your diet?",
    instructions_en: "Select all that apply.",
    choices_en: JSON.stringify([
      "Vegetarian",
      "Vegan",
      "Pescatarian",
      "Omnivore",
      "None of the above",
    ]),
    choices: JSON.stringify([
      "Vegetarian",
      "Vegan",
      "Pescatarian",
      "Omnivore",
      "None of the above",
    ]),
  },
  {
    id: "14",
    question_type: "radio",
    question:
      "That's everything we need. Would you like to complete the questionnaire now?",
    instructions_en: "Choose one answer.",
    choices_en: JSON.stringify([
      "Yes, complete and view my report",
      "No, finish later",
    ]),
  },
];